export default "__VITE_ASSET__BckUm3kY__"